import React from "react";
import ParallaxBanner from "../../components/ParallaxBanner/ParallaxBanner";
import Cta from "../../components/Cta/Cta";
import Button from "../../components/Button/Button";
import Featured from "../../components/Featured/Featured";
import { Slider } from "../../components/Slider/Slider";
import Odometers from "../../components/Odometers/Odometers";
import imgAzienda from "../../assets/azienda/L1180313.jpg";
import imgServizi1 from "../../assets/servizi/service11.jpg";
import imgServizi2 from "../../assets/servizi/service22.jpg";
import imgServizi3 from "../../assets/servizi/service33.jpg";

const Home = () => {
  return (
    <>
      <Slider />
      <section className="home_company pt pb">
        <div className="container">
          <div className="row align-items-center">
            <div className="col-6">
              <img src={imgAzienda} alt="azienda" />
            </div>
            <div className="col-6">
              <div className="pre">CHI SIAMO</div>
              <h2>La giusta soluzione<br />per ogni esigenza</h2>
              <p>
                Italimpianti s.r.l. nasce nel 2014, dall'unione di due società
                con esperienze diverse, una nel settore delle opere civili e
                l'altra nei servizi all'industria, con specializzazione
                nell'impiantistica elettrica e nei montaggi industriali.
              </p>
              <div className="buttons">
                <Button link="/azienda" testo="Scopri di più" stile="1" />
              </div>
            </div>
          </div>
        </div>
      </section>
      <Odometers />
      <ParallaxBanner />
      <section className="home_servizi pt pb">
        <div className="container">
          <div className="intro text-center mb2">
            <div className="pre">COSA FACCIAMO</div>
            <h2 className="mb0">I nostri servizi</h2>
          </div>

          <div className="row">
            <div className="col-4">
              <div className="servizi__item">
                <div className="servizi__img">
                  <img src={imgServizi1} />
                </div>
                <div className="servizi__text">
                  <h3>Quadri elettrici industriali</h3>
                  <p>
                    Siamo in grado di sviluppare molteplici applicazioni di
                    controllo e supervisione cercando di individuare la giusta
                    soluzione per ogni esigenza il tutto in stretta
                    collaborazione con il cliente
                  </p>
                </div>
              </div>
            </div>
            <div className="col-4">
              <div className="servizi__item">
                <div className="servizi__img">
                  <img src={imgServizi2} />
                </div>
                <div className="servizi__text">
                  <h3>Edilizia</h3>
                  <p>
                    Il settore costruzioni di Italimpianti opera con successo in
                    Italia con un raggio d’azione che varia dal residenziale al
                    commerciale, dall’industriale alle urbanizzazioni, fino ai
                    lavori speciali.
                  </p>
                </div>
              </div>
            </div>
            <div className="col-4">
              <div className="servizi__item">
                <div className="servizi__img">
                  <img src={imgServizi3} />
                </div>
                <div className="servizi__text">
                  <h3>Officina meccanica</h3>
                  <p>
                    Operiamo nel settore con professionalità, avvalendosi di
                    personale qualificato è in grado di realizzare impianti
                    chiavi in mano sia nel settore civile che industriale.
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
      {/* <Featured /> */}
      <Cta />
    </>
  );
};

export default Home;
